// Mirrors Stevie.Cloud.Api.vNext.Models.Casing (ADR 009).
// Backend uses JsonStringEnumConverter with no naming policy, so wire values
// are the C# member names verbatim (`Match`, `Upper`, `Lower`).
export type Casing = 'Match' | 'Upper' | 'Lower';

export const ALL_CASINGS: readonly Casing[] = ['Match', 'Upper', 'Lower'] as const;
